export function Item6() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        A Simya Capital atua como um elo estratégico entre empresas, utilizando
        a rede de relacionamentos da sua equipe para conectar compradores e
        vendedores em diversas transações, como:
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Compra e venda de empresas: Auxiliamos na busca por empresas que se
        encaixam em seu perfil de investimento e nos seus objetivos
        estratégicos. Realizamos a avaliação de empresas à venda e assessoramos
        em todo o processo de negociação e compra. Vendemos sua empresa para o
        comprador ideal, obtendo o melhor preço possível no mercado.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Fusões e aquisições: Estruturamos e acompanhamos fusões e aquisições
        desde a identificação de oportunidades até a integração das empresas.
        Assessoramos na análise de riscos e potenciais retornos de cada
        operação. Garantimos que a transação seja realizada de forma eficiente e
        segura, protegendo seus interesses.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4">
        Joint ventures: Auxiliamos na criação e estruturação de joint ventures,
        parcerias estratégicas entre empresas. Negociamos os termos da parceria
        e elaboramos os contratos para garantir o sucesso do negócio.
        Acompanhamos a gestão da joint venture e oferecemos suporte para a
        resolução de conflitos.
      </p>
    </>
  );
}
